<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Exportar Aula</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
              <form @submit.prevent="handleSubmit(enableSubmit)" :disabled="false">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Turma</e-label>
                      <p class="font-weight-regular">
                        <v-select
                          :items="turmas"
                          item-text="turma.descricao"
                          item-value="turma.id"
                          :hint="`${turmaSelecionada?.turma?.franquia?.descricao}`"
                          return-object
                          label="Selecione o campo abaixo"
                          v-model="turmaSelecionada"
                          :error-messages="errors"
                          autocomplete="off"
                        ></v-select>
                      </p>
                    </ValidationProvider>
                  </v-col>

                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.tipo_de_aula }}
                    </p>
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="12" v-if="gestaoParaDatePicker">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <e-label>Selecione uma data</e-label>
                      <e-date-picker-calendario-letivo
                        ref="datePickerCalendarioLetivo"
                        v-model="dataAulaDuplicada"
                        :gestao-de-aula="gestaoParaDatePicker"
                        :inicio-periodo-etapa="etapa?.periodo_inicial"
                        :fim-periodo-etapa="etapa?.periodo_final"
                        :error-messages="errors"
                        label="Escolha uma data"
                        @date-changed="onDateChanged"
                        @horarios-changed="onHorariosChanged"
                      />
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    class="pt-0 pb-0"
                    v-if="gestaoDeAula.tipo_de_aula !== 'Aula Remota' && gestaoParaDatePicker"
                    cols="12"
                  >
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <v-select
                        :items="horariosDisponiveis"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                        solo
                        autocomplete="off"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="12" v-else>
                    <v-alert color="warning" dense outlined type="warning">
                      Escolha uma turma antes de selecionar data e horário.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Conteúdo</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.conteudo }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Metodologia</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.metodologia }}
                    </p>
                  </v-col>
                </v-row>

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperadosFiltrados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false), limparCampos()"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="!totalmentePreenchido"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="exportarAula"
    >
    </e-modal-confirm>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    etapa: {
      type: Object,
    },
  },
  data() {
    return {
      dataAulaDuplicada: null,
      gestaoDeAula: {},
      horariosDisponiveis: [],
      confirmDialog: false,
      turmas: [],
      turmaSelecionada: {
        turma: {
          id: null,
          franquia: {
            descricao: "",
            fantasia: "",
          },
        },
      },
      objectModal: {
        title: "Exportar aula",
        message: "Tem certeza que deseja exportar esta aula?",
      },
      horarioSelecionado: null,
      itemsEsperados: [
        { label: "Turma", value: "turmaSelecionada" },
        { label: "Data", value: "dataAulaDuplicada" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
    };
  },
  computed: {
    aulaRemota() {
      return this.gestaoDeAula?.tipo_de_aula === "Aula Remota";
    },
    itemsEsperadosFiltrados() {
      if (this.aulaRemota) {
        return this.itemsEsperados.filter((item) => item.value !== "horarioSelecionado");
      }
      return this.itemsEsperados;
    },
    gestaoParaDatePicker() {
      if (!this.turmaSelecionada?.relacoesDiasHorarios) {
        return null;
      }

      return {
        turma: this.turmaSelecionada.turma,
        relacoesDiasHorarios: this.turmaSelecionada.relacoesDiasHorarios,
        disciplina: this.gestaoDeAula?.disciplina,
      };
    },
  },
  created() {
    // Cria um watcher para cada item esperado (value).
    this.itemsEsperadosFiltrados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.gestaoDeAula = val;
      },
    },
    turmaSelecionada: {
      immediate: true,
      handler(val) {
        if (val?.turma?.id) {
          this.dataAulaDuplicada = null;
          this.horarioSelecionado = null;
          this.horariosDisponiveis = [];
        }
      },
    },
    dialog: {
      async handler(val) {
        if (val) {
          this.$loaderService.open("Carregando gestões de aula");
          try {
            this.turmas = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
              this.gestaoDeAula
            );
          } catch (error) {
            this.$handleError(error);
          } finally {
            this.$loaderService.close();
          }
        }
      },
    },
  },
  methods: {
    onDateChanged() {
      this.horarioSelecionado = null;
    },

    onHorariosChanged(horarios) {
      this.horariosDisponiveis = horarios;

      if (this.horarioSelecionado) {
        const horarioExists = horarios.some((h) => h.id === this.horarioSelecionado.id);
        if (!horarioExists) {
          this.horarioSelecionado = null;
        }
      }
    },

    enableSubmit() {
      if (
        !this.turmaSelecionada?.turma?.id ||
        !this.dataAulaDuplicada ||
        !this.horarioSelecionado?.id
      ) {
        this.$toast.danger("Preencha todos os campos obrigatórios: turma, data e horário.");
        return;
      }
      this.confirmDialog = !this.confirmDialog;
    },
    async exportarAula() {
      this.$loaderService.open("Exportando a Aula");
      try {
        const partesData = this.dataAulaDuplicada.split("/");
        const dataFormatada = `${partesData[2]}-${partesData[1]}-${partesData[0]}`;

        this.gestaoDeAula.data = dataFormatada;
        this.gestaoDeAula.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.gestaoDeAula.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.gestaoDeAula.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.gestaoDeAula.instrutorDisciplinaTurma_id = parseInt(this.turmaSelecionada.id, 10);
        this.gestaoDeAula.turma_id = this.turmaSelecionada.turma.id;
        this.confirmDialog = !this.confirmDialog;

        this.$emit("dialogChange", false);
        await this.$services.aulasService.criar(this.gestaoDeAula);

        this.$toast.success("Aula exportada com sucesso!");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.limparCampos();
        this.$loaderService.close();
      }
    },
    limparCampos() {
      this.dataAulaDuplicada = null;
      this.turmaSelecionada = null;
      this.horariosDisponiveis = [];
      this.dataAulaDuplicada = null;
      this.horarioSelecionado = null;
      this.totalmentePreenchido = false;

      if (this.$refs.datePickerCalendarioLetivo) {
        this.$refs.datePickerCalendarioLetivo.limpar();
      }

      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
    },
  },
};
</script>
